import React from 'react';
import PropTypes from 'prop-types';
import './CaseCountDisplay.scss';

const CaseCountDisplay = ({ dataColumns, caseCountData, workableCount }) => {
  return (
    <div className="case-count-display">
      <ul className="case-count-display-list">
        {
                    dataColumns.map((column) => {
                      let value;
                      if (column.displayType === 'STRING') {
                        value = (
                          <div>
                            {caseCountData[`${column.columnKey}`] ? caseCountData[`${column.columnKey}`] : '--'}
                          </div>
                            );
                      } else if (column.displayType === 'CRITICAL') {
                        value = (
                          <div className="critical-cases">
                            {caseCountData[`${column.columnKey}`] ? caseCountData[`${column.columnKey}`] : '--'}
                          </div>
                            );
                      } else if (column.displayType === 'WORKABLE') {
                        value = (
                          <div>
                            { workableCount ? workableCount : '--'}
                          </div>
                            );
                      } 
                      return (
                        <li
                          className="case-count-display-list-item"
                          key={column.columnKey}
                        >
                          <div className="case-count-display-list-item-wrapper">
                            <span className="case-count-display-list-item-label">
                              {column.title}
                            </span>
                          </div>
                          <span className={'case-count-display-list-item-amount'}>
                            {value}
                          </span>
                        </li>
                      );
                    })
                }
      </ul>
    </div>
  );
};

CaseCountDisplay.props = {
  dataColumns: PropTypes.array,
  caseCountData: PropTypes.object,
};

CaseCountDisplay.defaultProps = {
  dataColumns: [],
  caseCountData: {},
};

export default CaseCountDisplay;
